import bem from 'utils/bem';

export const block = bem('onboarding-animations');
export const blockTooltip = bem('onboarding-animations-tooltip');
export const blockBeacon = bem('onboarding-animations-beacon');
